<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png" /> -->
  <HomePage />
</template>

<script>
import HomePage from "./components/HomePage.vue";

export default {
  name: "App",
  components: {
    HomePage,
  },
};
</script>

<style></style>
